import {Service} from "@/apiServices/Service";

export class TratamientoProgramadoService extends Service {
    constructor() {
        super('catalogos/');
    }

    /*obtenerTratamientosProgramadosPorRecibo(idRecibo){
        return this.http.get(this.getUrl(['obtener','tratamientosProgramados','recibo'], {idRecibo}))
            .then((response)=> this.onData(response))
            .then((response)=> this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }*/

    obtenerTratamientosProgramadosPorReciboUnicos(idRecibo){
        return this.http.get(this.getUrl(['obtener','tratamientosProgramados','sinReembolso'], {idRecibo}))
            .then((response)=> this.onData(response))
            .then((response)=> this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}
